/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { Component, createRef, Fragment } from "react";
import { Tooltip, UncontrolledTooltip } from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Draggable from "react-draggable";
import {
  doctorAppointmentData,
  doctorOnlineState,
  saveSessionId,
  saveTimerStatus,
  saveVideoCallData
} from "../../reduxStore/actions/commonAction";
import Modal from "../../components/modal";
import Label from "../../components/label";
import IconButton from "../../components/iconButton";
import DefaultPic from "../../assets/images/default-picture.png";
import Loader from "../../components/loader";
import Button from "../../components/button";
import {
  cancelCallByDoctor,
  changeAppointmentStatus,
  changeDoctorBusyState,
  closeVideoCallScreenApiRoute,
  connectCallApiRoute,
  endCallByDoctor,
  endTimerPatientCall,
  getBookingDetails,
  makeACall,
  sendSMSToPatientForVideoCallApiRoute
} from "../../apiRoutes";
import MakeAPICall from "../../apiCalls/common";
import appRoutes from "../../routes/appRoutes";
import socket from "../../utils/socket";
import APP_CONSTANTS from "../../constants";
import deviceCheck from "../../utils/checkDevice";
import ICInput from "../../components/form/input";

const conn = socket;
let connectedUser;
let yourConn;
let stream;
let initiateVideoCall = false;
let patientAcceptedCall = false;

class CallRequestAccepted extends Component {
  constructor(props) {
    super(props);
    this.state = {
      doctorData: props.userData, // current doctor data
      isLoading: false, // insta custom loader
      showCancelConsultPopup: false,
      cancelConsultReason: "",
      cancelConsultReasonError: false,
      callRequestData: props.location.state.callRequestData || null, // call request data
      isPMSDirectCall: props.location.state.directCall || false, // check if it is direct call from PMS? if it is then allow handle All message on appointment id check
      commonReducers: props.commonReducers, // store reducers
      apiCall: null, // used for api call
      apiCall1: null,
      // bookingData: null, // get appointment data here
      bookingData: null, // get appointment data here
      clearTimer: null, // clear 5 minute time
      timer: null, // timer function
      hideCallBtn: true, // hide call button after 5 minute
      localVideo: null, // used for video call
      remoteVideo: null, // used for video call
      patientData: null, // used for video call,
      videoAllow: true, // local video allowed to user
      audioAllow: true, // local audio allowed to user
      endVideoCallPopUp: false, // confirm end video call popup
      callBtnDisable: false, // call button is disabled after call button hit ones,
      callingPatientPopupState: false, // ones call button hit, and make a call api calling, this state will be true to show popup
      pleaseWait: false, // please wait pop-up added due to timer in mobile apps
      showVideoContainer: false, // Video container - draggable show and hide,
      videoContainerMinimize: true, // small size video container
      videoContainerPosition: { x: 105, y: 130 }, // video container default position

      activeDrags: 0, // for dragging video call container
      deltaPosition: {
        // for dragging video call container
        x: 0,
        y: 0
      },
      controlledPosition: {
        // for dragging video call container
        x: -400,
        y: 200
      },

      acceptedCallByPatient: null, // data when notification flag === 2, patient data - if it's from PMS then there is not data

      videoCallTimer: false, // to pause and play video call status
      timernewvalue: this.props.commonReducers.videoCallData
        ? this.props.commonReducers.videoCallData.timerVal
        : 0, // for video call pause,
      videoTimerValue: null, // video timer value,
      timernew: 0, // for storing video timer interval

      patientRejectedVideoCallFromDoctorState: false, // patient rejected video call from doctor when doctor tried to push call button
      patientRejectedVideoCallFromDoctorContent: "", // model body content from backend when patient reject a call from doctor

      paymentReceiptReceivedOnEndCallState: false, // when doctor ends the call, receipt for doctor is available model
      paymentReceiptReceivedOnEndCallContent: null, // data when doctor ends the call, receipt

      consultSummaryId: null, // end call last api - appointment Id to go to consult history

      patientDisconnected: false, // after accept the video call on patient, if patient video is disconnected then this variable is true

      doctorDisconnectedCall: false, // if doctor disconnect call by himself then there is no poor connection on patient side and we can end video call successfully

      sessionId:
        this.props.commonReducers.sessionId !== null
          ? this.props.commonReducers.sessionId
          : "", // session id store here and in redux as well - got in make a call api

      pictureInPictureBtnState: true, // default picture in picture button in video container is false, when video loads then we will enable it
      patientCancelledRequest: false,
      patientDeviceIssuePopup: false,

      isCallConnected: false, // added flag to call api only once when call connected using ice Candidate state change event
      remoteVideoTimerCountAfterLocalVideo: null, // checking remote video is connection withing 15 sec or not; if not connected then there is an issue with patient device
      doctorOffline: false, // doctor is default online
      timerForDoctorInternetLoss: null, // timer for internet lost,
      // consult timer handling
      consultTimerInterval: null,
      consultTimerStartPoint: 0,
      consultTimerStatus: false,
      consultTimerValue: "0 sec",
      disableConsultCallBtn: false,
      phoneCallButtonWording: "Phone Call <br />(Video Call Failed)",
      patientDeviceIssueState: false, // show popup if flag == 6 which means issue with patient device to accept the call
      patientDeviceIssueContent: null, // pop-up body for patient device issue (getting fromm backend)
      copyTextToolTip: false, // tooltip during copy text
      bulkBilledTextForCopy: '', // text to show bulkBilled
      copyTextHoverToolTip: false, // copy text hover tooltip
    };
    this.remoteVideoRef = createRef(); // remote video element reference
  }

  async componentDidMount() {
    let _this = this;
    await this.resetVariables();

    // instead of setting from props directly, we will set when component did mount
    this.setState({
      callRequestData: this.props.location.state.callRequestData,
      bookingData: this.props.location.state.bookingDataFromQueuePage && this.props.location.state.bookingDataFromQueuePage.data && this.props.location.state.bookingDataFromQueuePage.data.data ? JSON.parse(this.props.location.state.bookingDataFromQueuePage.data.data.data) : null,
    })

    // getting device info - if firefox then there is not Picture in picture button because it's not supported yet default
    let deviceInfo = deviceCheck();
    if (deviceInfo.name === "mozilla")
      this.setState({
        pictureInPictureBtnState: false
      });
    console.log("Device info in call request : ", deviceInfo);

    console.log(
      "Call request accepted page - common reducers : ",
      this.props.commonReducers
    );
    console.log(
      "Call request accepted page - consult data : ",
      this.props.location.state.callRequestData
    );

    console.log("Call request page is loded now:::");


    console.log("Just adding for build");

    _this.setState({
      timerForDoctorInternetLoss: setInterval(
        _this.checkInternetConnetionInLoop,
        1000
      )
    });

    // if (
    //   this.props.location.state &&
    //   this.props.location.state.callRequestData
    // ) {
    console.log("Getting booking data here");
    // this.getBookingData();
    //using Google public stun server
    let configuration = {
      iceServers: APP_CONSTANTS.iceServers
    };
    // let configuration = {
    //   iceServers: [
    //     {
    //       url: "turn:52.63.101.235",
    //       username: "prouser",
    //       credential: "3TptDG7cAfz5TaXsda"
    //     }
    //   ]
    // };
    yourConn = await new RTCPeerConnection(configuration);
    console.log("&&&&&&&&&&&&&&&& Your Conn &&&&&&&&&&&&&&&&&&&&&&&&&&");
    console.log(yourConn);

    // yourConn.ontrack = this.handleConnectionOnTrack;
    // yourConn.onsignalingstatechange = this.handleSignalingStateChangeEvent;
    yourConn.oniceconnectionstatechange = () => {
      console.log(
        "Inside on Ice connection state change ",
        yourConn.iceConnectionState
      );
      if (yourConn.iceConnectionState === "connected") {
        //when a remote user adds stream to the peer connection, we display it
        console.log("Both users are connected");
        if (_this.state.isCallConnected === false) {
          _this.connectCallApi();
          // I'm having a problem in updating state. "showVideoContainer" should work but it wans't working so I have added that code here. When both users are connected then this function will execute if video container is not
          if (!_this.state.showVideoContainer) {
            _this.setState({
              pleaseWait: false,
              disableConsultCallBtn: true,
              callingPatientPopupState: false,
              showVideoContainer: true,
            });
          }
        }
      } else if (yourConn.iceConnectionState === "disconnected") {
        console.log("Disconnected from doctor?: ", navigator.onLine);
        if (_this.state.doctorDisconnectedCall === false) {
          console.log("Now showing poor connection pop-up");

          if (_this.state.doctorOffline === false) {
            _this.addIssueWithPatientDeviceOnCall();
          } else {
            _this.addIssueWithDoctorDeviceOnCall();
          }

          _this.setState({
            patientDisconnected: true,
            doctorDisconnectedCall: true
          });
          _this.safetyCheckCamera();
        }
      }
    };

    console.log(
      "################### Checking Session Id here ######################################"
    );
    console.log(this.props.commonReducers);
    this.setState({
      sessionId: this.props.commonReducers.sessionId
    });

    // we are having an issue with Chrome multiple API calls as Chrome give us CROS origin error while doing multiple api calls at once, but now we have added retry npm in main api call.
    this.getBookingData();

    // }

    // handle messages sent by server for video call only
    conn.on("message", msg => {
      let data = "";
      try {
        data = JSON.parse(msg);
      } catch (err) {
        data = msg;
      }

      let appointmentIdCheck = null;
      if (
        this.state.callRequestData &&
        this.state.callRequestData.data.data.appointmentId
      ) {
        appointmentIdCheck = this.state.callRequestData.data.data.appointmentId;
      } else if (this.props.commonReducers.appointmentData) {
        appointmentIdCheck = this.props.commonReducers.appointmentData._id;
      }

      if (data.type === 'initiateVideoAgain' && appointmentIdCheck === data.data.appointmentId) {
        console.log("*** Patinet requested initiateVideoCallAgain ****");
        this.handleAllMsg(data);
      }

      if (data.data && data.data.data && data.type === 'initiateVideoAgain' && appointmentIdCheck === data.data.data.appointmentId) {
        console.log("*** Patinet requested initiateVideoCallAgain ****");
        this.handleAllMsg(data);
      }

      if (
        _this.state.bookingData &&
        data.appointmentId === _this.state.bookingData._id &&
        data.from !== "doctor" && data.type !== undefined
      ) {
        this.handleAllMsg(data);
      } else if (data.appointmentId === appointmentIdCheck && data.type !== undefined && data.from !== "doctor") {
        this.handleAllMsg(data);
      } else if (data.data && data.data.appointmentId === appointmentIdCheck && data.data.type !== undefined && data.data.from !== "doctor") {
        this.handleAllMsg(data.data);
      } else if (data.data && data.data.data && data.type !== undefined && data.data.data.appointmentId === appointmentIdCheck && data.data.from !== "doctor") {
        // checking PMS web call
        console.log("Web socket: ");
        this.handleAllMsg(data.data);
      } else if (data.type !== undefined && data.appointmentId === appointmentIdCheck && data.from !== "doctor") {
        // handle offer/candidate/anser from WEB patient (don't know why this is needed this time - have changed a lot from the first build)
        this.handleAllMsg(data);
      }
      else if (
        data.data &&
        data.data.appointmentId &&
        _this.state.bookingData &&
        data.data.appointmentId === _this.state.bookingData._id &&
        data.from !== "doctor" &&
        data.type === "initiateVideoCall" &&
        this.state.bookingData.directCall === false
      ) {
        this.handleAllMsg(data);
      } else if (
        data.data &&
        data.data.data &&
        _this.state.bookingData &&
        data.data.data.appointmentId === _this.state.bookingData._id &&
        data.data.from !== "doctor" &&
        data.type === "initiateVideoCall" &&
        this.state.bookingData.directCall === false
      ) {
        this.handleAllMsg(data.data);
      }
      else if (
        data.data &&
        data.data.appointmentId &&
        this.state.bookingData &&
        this.state.callRequestData &&
        data.data.appointmentId === _this.props.location.state.callRequestData.data.data.appointmentId &&
        data.from !== "doctor" &&
        data.type === "initiateVideoCall" &&
        this.state.bookingData.directCall === false
      ) {
        this.handleAllMsg(data);
      } else if (
        data.data &&
        data.data.data &&
        this.state.bookingData &&
        this.state.callRequestData &&
        data.data.data.appointmentId === _this.props.location.state.callRequestData.data.data.appointmentId &&
        data.data.from !== "doctor" &&
        data.type === "initiateVideoCall" &&
        this.state.bookingData.directCall === false
      ) {
        this.handleAllMsg(data.data);
      } else if (data.appointmentId === appointmentIdCheck) {
        this.handleAllMsg(data);
      }
    });

    // handle some web notifications
    conn.on("webNotification", data => {
      // console.log(
      //   "Web notification data : ",
      //   data,
      //   data.data.data.appointmentId
      // );
      // console.log(
      //   "Props data to match : ",
      //   this.props.location.state.callRequestData
      // );

      // console.log("This callRequestData: ", this.state.callRequestData);

      // console.log("Hey check here for flag 3: ", data.data.data.flag === 3,
      //   this.props.location.state.callRequestData,
      //   data.data.data.appointmentId,
      //   this.props.location.state.callRequestData.data.data.appointmentId);


      let appointmentIdCheck = null;
      if (
        this.state.callRequestData &&
        this.state.callRequestData.data.data.appointmentId
      ) {
        appointmentIdCheck = this.state.callRequestData.data.data.appointmentId;
      } else if (this.props.commonReducers.appointmentData) {
        appointmentIdCheck = this.props.commonReducers.appointmentData._id;
      }



      let flagId = data.data.data.flag;
      if (
        flagId === 2 ||
        flagId === 3 ||
        flagId === 29 ||
        flagId === 28 ||
        flagId === 30
      ) {
        // if (
        //   data.data.data.flag === 2 &&
        //   this.props.location.state.callRequestData &&
        //   data.data.data.appointmentId ===
        //     this.props.location.state.callRequestData.data.data.appointmentId
        // ) {
        //   console.log("Patient accepted a call");

        //   // this.setState({
        //   //   callingPatientPopupState: false,
        //   //   acceptedCallByPatient: data.data
        //   // });
        //   // this.startLocalVideo(() => {
        //   //   console.log(
        //   //     "*********************** Call Back **********************"
        //   //   );
        //   //   console.log(
        //   //     "Now calling to patient : ",
        //   //     this.state.callRequestData
        //   //   );
        //   //   let callToUsername = this.state.callRequestData.data.data.patientId,
        //   //     _this = this;

        //   //   console.log("Calling to this patient : ", callToUsername);

        //   //   if (callToUsername.length > 0) {
        //   //     connectedUser = callToUsername;

        //   //     if (yourConn) {
        //   //       // create an offer
        //   //       console.log("NOw creating a offer");
        //   //       yourConn.createOffer(
        //   //         function(offer) {
        //   //           send({
        //   //             type: "offer",
        //   //             offer: offer,
        //   //             appointmentId: _this.state.bookingData._id,
        //   //             from: "doctor"
        //   //           });
        //   //           console.log("Offer sent");

        //   //           yourConn.setLocalDescription(offer);
        //   //         },
        //   //         function(error) {
        //   //           alert("Error when creating an offer");
        //   //         }
        //   //       );
        //   //     }
        //   //   }
        //   // });
        //   // making_a_call_dialog
        //   // storing this event in localstorage
        // } 
        if (
          data &&
          data._id !== undefined &&
          data.data.data.flag === 2 &&
          this.state.doctorData._id === data._id
        ) {
          console.log("Patient accepted a call ***");
          patientAcceptedCall = true;
          this.setState({
            pleaseWait: true
          });
        }
        else if (
          data.data.data.flag === 3 &&
          this.state.callRequestData &&
          data.data.data.appointmentId ===
          this.props.location.state.callRequestData.data.data.appointmentId
        ) {
          // patient rejected a call when doctor tried to video call patient
          // console.log("Patient reject a call");
          // console.log(data.data);
          // console.log("2-> ", data.data.data);
          // console.log("Patient ID to match: ", data.data.data.patientId);
          // console.log("Appointment id to match: ", data.data.data.appointmentId, appointmentIdCheck);
          // console.log("Doctor Id to match: ", data.data.data.doctorId);
          // this will take care of the cancelled and reject call both
          this.handleCallEndFromAdminUsecase();

          // this.setState({
          //   patientRejectedVideoCallFromDoctorContent: data.data.contents.en,
          //   patientRejectedVideoCallFromDoctorState: true
          // });
        } else if (
          data.data.data.flag === 29 &&
          this.state.callRequestData &&
          data.data.data.appointmentId ===
          this.props.location.state.callRequestData.data.data.appointmentId
          // doctor call disconnected
        ) {
          console.log("Booking data on end call: ", this.state.bookingData);
          // add data.data.data.endCall == "doctor in condition"
          console.log("Disconnected doctor call");
          this.endCallFromAdmin();
        }

        // if admin ends the call and we have not yet called the patient or is in calling state
        else if (
          data.data.data.flag === 28 &&
          this.state.callRequestData &&
          data.data.data.appointmentId ===
          this.props.location.state.callRequestData.data.data.appointmentId
        ) {
          this.handleCallEndFromAdminUsecase();
        } else if (
          data.data.data.flag === 30 &&
          this.state.callRequestData &&
          data.data.data.appointmentId ===
          this.props.location.state.callRequestData.data.data.appointmentId
        ) {
          this.setState({
            callingPatientPopupState: false,
            callBtnDisable: true,
            hideCallBtn: true,
            disableConsultCallBtn: true
          });
          this.handlePatientCallNoPickup(data);
        }
        // else if(
        //   data.data.data.flag === 5 && data.data.data.doctorId === this.state.doctorData._id
        // ){
        //   console.log("End call from admin : ", data);
        // }
      }
    });

    // we had a problem of CROS in chrome, so we have added timeout; but now we have added retry api call, so we dont need to wait
    // // after one second call this API to set booking data
    // setTimeout(() => {
    //   this.getBookingData();
    // }, 600);

    // PROBLEM: when we close the Picture-In-Picture from po-up window, it pause the running video, so we have to enable it manually
    // Remember to remove event listener once "leave" socket event fired
    this.remoteVideoRef.current.addEventListener('leavepictureinpicture', pictureInPictureLeaveEvent);
  }

  componentWillUnmount() {
    clearInterval(this.state.timernew);
    clearInterval(this.clearTimer);
    clearInterval(this.state.consultTimerInterval);
    this.setState({
      disableConsultCallBtn: false,
      callRequestData: null,
      bookingData: null
    });
  }

  callPatientPhoneButtonClicked = () => {
    if (this.state.bookingData) {
      let apiCallParam = {
        reqType: "GET",
        reqURL: sendSMSToPatientForVideoCallApiRoute,
        dataObj: {},
        params: {
          appointmentId: this.state.bookingData
            ? this.state.bookingData.appointmentId
            : "",
          patientId: this.state.bookingData
            ? this.state.bookingData.patientId._id
            : "",
          phoneNumber: this.state.bookingData
            ? this.state.bookingData.patientId.phoneNumber
            : ""
        },
        headers: {},
        successCallback: async res => {
          console.log("Video Close API CALL DONE.");
        },
        failureCallback: err => {
          console.log("Video Close API CALL ERROR : ", err);
        },
        showPopUp: false
      };
      this.setState({
        apiCall: apiCallParam
      });
    }

    let pn = this.state.bookingData
      ? this.state.bookingData.patientId.phoneNumber.replace(/\s/g, "")
      : "";

    if (pn !== "") {
      pn = pn.slice(0, 4) + " " + pn.slice(4, 7) + " " + pn.slice(7, 10);
    }

    this.setState({
      phoneCallButtonWording: "Dial #31#<br />" + pn
    });

    // window.open(
    //   "tel:#31#" +
    //     (this.state.bookingData
    //       ? this.state.bookingData.patientId.phoneNumber
    //       : "")
    // );
  };

  startConsultTimer = () => {
    let startTimer = this.state.consultTimerStartPoint;
    startTimer++;
    console.log("Starting Consult timer : ", startTimer);
    let d = Number(startTimer),
      h = Math.floor(d / 3600),
      m = Math.floor((d % 3600) / 60),
      s = Math.floor((d % 3600) % 60),
      hDisplay = h > 0 ? h + (h === 1 ? " hour : " : " hours : ") : "",
      mDisplay = m > 0 ? m + (m === 1 ? " min : " : " mins : ") : "",
      sDisplay = s > 0 ? s + (s === 1 ? " sec" : " secs") : "";

    this.setState({
      consultTimerStatus: true,
      consultTimerValue: hDisplay + mDisplay + sDisplay
    });

    this.setState({
      consultTimerInterval: setInterval(() => {
        if (this.state.consultTimerInterval !== null) {
          startTimer++;
          let d = Number(startTimer),
            h = Math.floor(d / 3600),
            m = Math.floor((d % 3600) / 60),
            s = Math.floor((d % 3600) % 60);
          let hDisplay = h > 0 ? h + (h === 1 ? " hour : " : " hours : ") : "";
          let mDisplay = m > 0 ? m + (m === 1 ? " min : " : " mins : ") : "";
          let sDisplay = s > 0 ? s + (s === 1 ? " sec" : " secs") : "";
          this.setState({
            consultTimerValue: hDisplay + mDisplay + sDisplay,
            consultTimerStartPoint: startTimer
          });
        }
      }, 1000)
    });
  };

  stopConsultTimer = () => {
    clearInterval(this.state.consultTimerInterval);
    this.setState({
      consultTimerStatus: false,
      consultTimerInterval: null
    });
  };

  handleConnectionOnTrack = event => {
    console.log("Data on Track : ", event);
  };

  checkInternetConnetionInLoop = () => {
    if (navigator.onLine) {
      this.setState({
        doctorOffline: false
      });
    } else {
      this.setState({
        doctorOffline: true
      });
      clearInterval(this.state.timerForDoctorInternetLoss);
    }
  };

  // if admin end the call and we have not yet called the patient or is in calling state
  handleCallEndFromAdminUsecase = () => {
    clearInterval(this.clearTimer);

    // if the doctor is receiving the patient consult request popup
    this.setState({
      callingPatientPopupState: false,
      patientCancelledRequest: true
    });

    this.resetVideoCallReduxState();
    this.safetyCheckCamera();
    this.changeDoctorBusyStatusWithCallBack(false, (err, res) => { });
  };

  patientCancelledRequestFromAdmin = () => {
    this.setState({
      patientCancelledRequest: false
    });
    this.goToDashboard();
    this.changeDoctorBusyStatusWithCallBack(false, (err, res) => {
      this.resetVideoCallReduxState();
    });
  };

  endCallFromAdmin = () => {
    this.safetyCheckCamera();
    clearInterval(this.clearTimer);

    this.setState({
      // paymentReceiptReceivedOnEndCallContent: data.data.contents.en
      paymentReceiptReceivedOnEndCallContent:
        "You have ended the video call for Consult ID: " +
        this.state.bookingData.appointmentId,
      paymentReceiptReceivedOnEndCallState: true,
      consultSummaryId: this.state.bookingData._id
    });
    this.resetVideoCallReduxState();
  };

  safetyCheckCamera = () => {
    if (stream) {
      stream.getTracks().forEach(track => {
        track.stop();
      });
    }
    connectedUser = null;
    // remoteVideo.src = null;
    let remoteVideoEle = document.querySelector("#remoteVideo");
    if (remoteVideoEle) remoteVideoEle.srcObject = null;

    let localVideoEle = document.querySelector("#localVideo");
    if (localVideoEle) localVideoEle.srcObject = null;

    // yourConn.close();
    yourConn.onicecandidate = null;
    yourConn.onaddstream = null;
  };

  handleSignalingStateChangeEvent = event => {
    console.log("Signalling event is here: ", event);
    console.log("Connection signal state : ", yourConn.signalingState);
    switch (yourConn.signalingState) {
      case "closed":
        // closeVideoCall();
        console.log("Now close the video");
        break;
    }
  };

  // for resetting variables
  resetVariables = () => {
    clearInterval(this.clearTimer);
    this.setState({
      clearTimer: null, // clear 5 minute time
      timer: null, // timer function
      videoCallTimer: false, // to pause and play video call status
      timernewvalue: 0, // for video call pause,
      videoTimerValue: null, // video timer value,
      timernew: 0, // for storing video timer interval,
      sessionId: null, // session id,
      doctorDisconnectedCall: false, // patient poor connection problem no - default false, if there is problem then video call automatic detects the connection lost error and this variable is false - default,
      pictureInPictureBtnState: true, // default picture in picture button is false
      isCallConnected: false, // default is call connected is false
      doctorOffline: false, // doctor is default online
      timerForDoctorInternetLoss: null, // timer for internet lost
      callRequestData: null,
      bookingData: null
    });
    if (stream) {
      stream.getTracks().forEach(track => {
        track.stop();
      });
    }
    this.resetVideoCallReduxState();
  };

  // connect call api
  connectCallApi = async () => {
    let formData = new FormData();
    formData.append("userType", "Doctor");
    formData.append("appointmentId", this.state.bookingData._id);
    // formData.append("sessionId", this.props.commonReducers.sessionId);
    let sessionId = null;
    if (this.state.sessionId) sessionId = this.state.sessionId;
    else if (this.state.callRequestData.data.data.sessionId) {
      sessionId = this.state.callRequestData.data.data.sessionId;
    } else sessionId = this.props.commonReducers.sessionId;

    this.props.saveSessionId(sessionId);

    formData.append("sessionId", sessionId);

    console.log(
      "----------------------------------------- Session Id ---------------------------------------------"
    );
    console.log(
      "----------------------------------------- Session Id ---------------------------------------------"
    );
    console.log(
      "----------------------------------------- Session Id ---------------------------------------------"
    );
    console.log(
      "----------------------------------------- Session Id ---------------------------------------------"
    );
    console.log(
      "----------------------------------------- Session Id ---------------------------------------------"
    );
    console.log(
      "----------------------------------------- Session Id ---------------------------------------------"
    );
    console.log(sessionId);

    let apiCallObj = {
      reqType: "PUT",
      reqURL: connectCallApiRoute,
      dataObj: formData,
      headers: {},
      successCallback: async res => {
        //console.log("This data is saved inredux : ", res);
        this.setState({
          isCallConnected: true
        });
      },
      failureCallback: err => {
        //console.log("Got the error : ", err);
      }
    };
    this.setState({ apiCall1: apiCallObj });
  };

  // get the all appointment data here
  getBookingData = () => {
    console.log(
      "Booking data from common reducers : ",
      this.props.commonReducers
    );
    let appointmentIdCheck = null;
    if (
      this.state.callRequestData &&
      this.state.callRequestData.data.data.appointmentId
    ) {
      appointmentIdCheck = this.state.callRequestData.data.data.appointmentId;
    } else {
      appointmentIdCheck = this.props.commonReducers.appointmentData._id;
    }
    
    let bookingResponseData = this.props.location.state.bookingDataFromQueuePage;
    if (bookingResponseData) {
      console.log("I've already booking data: ", this.state.bookingData);
      this.getBookingDataSuccess(JSON.parse(bookingResponseData));
    } else {
      let apiCallParam = {
        reqType: "GET",
        reqURL: getBookingDetails,
        dataObj: {},
        params: {
          booking_id: appointmentIdCheck
        },
        headers: {},
        successCallback: async res => {
          console.log("Got the booking data here : ", res.data.data);
          this.getBookingDataSuccess(res);
        },
        failureCallback: err => {
          console.log("Something went wrong. Please try again : ", err);
        },
        showPopUp: false
      };
      this.setState({
        apiCall: apiCallParam
      });
    }
  };

  getBookingDataSuccess = (res) => {
    this.props.doctorAppointmentData(res.data.data);
    this.setState({
      bookingData: res.data.data
    });
    if (res.data.data.directCall) {
      this.directCallAllowed();
    } else {
      let fiveMinutes = 60 * 5;
      this.startTimer(fiveMinutes);
    }
    this.handleBulkBilledText();
  }

  handleBulkBilledText = () => {
    console.log("Now making bulk billed text");
    let text = '';
    if (this.state.bookingData && this.state.bookingData.isBulkBilled) {
      const bulkBilledText = this.state.bookingData.selectedCovidSituation;
      if (bulkBilledText.includes('self-isolate upon arrival')) {
        text = (<Fragment>
          <div>
            <span>Bulk-Billed Consult </span>
            (<span>Patient confirmed they have entered a state/territory with border restrictions requiring them to self-isolate upon arrival</span>)<span className="text-danger font-italic"> provide which state/territory</span>
          </div>
        </Fragment>);
      } else if (bulkBilledText.includes('living in a COVID-19 impacted are')) {
        text = (<Fragment>
          <div>
            <span>Bulk-Billed Consult </span>
            (<span>{`Patient confirmed they are living in a COVID-19 impacted area:${bulkBilledText.split(':')[1]}`}</span>)
          </div>
        </Fragment>);
      } else if (bulkBilledText.includes('homelessness')) {
        text = (<Fragment>
          <div>
            <span>Bulk-Billed Consult </span>
            (<span>Patient confirmed they are experiencing homelessness</span>)<span className="text-danger font-italic"> provide more specific details about living situation</span>
          </div>
        </Fragment>);
      } else if (bulkBilledText.includes('diagnosed with COVID-19')) {
        text = (<Fragment>
          <div>
            <span>Bulk-Billed Consult </span>
            (<span>Patient confirmed they have been diagnosed with COVID-19 and are isolating at home</span>)
          </div>
        </Fragment>);
      } else if (bulkBilledText.includes('awaiting results')) {
        text = (<Fragment>
          <div>
            <span>Bulk-Billed Consult </span>
            (<span>Patient confirmed they have been tested for COVID-19 and are awaiting results</span>)
          </div>
        </Fragment>);
      } else {
        text = (<span>Bulk-Billed Consult ({bulkBilledText})</span>);
      }
    }
    this.setState({
      bulkBilledTextForCopy: text
    });

  }

  // // get the all appointment data here
  // getBookingData = () => {
  //   console.log(
  //     "Booking data from common reducers : ",
  //     this.props.commonReducers
  //   );
  //   let appointmentIdCheck = null;
  //   if (
  //     this.state.callRequestData &&
  //     this.state.callRequestData.data.data.appointmentId
  //   ) {
  //     appointmentIdCheck = this.state.callRequestData.data.data.appointmentId;
  //   } else {
  //     appointmentIdCheck = this.props.commonReducers.appointmentData._id;
  //   }
  //   let apiCallParam = {
  //     reqType: "GET",
  //     reqURL: getBookingDetails,
  //     dataObj: {},
  //     params: {
  //       booking_id: appointmentIdCheck
  //     },
  //     headers: {},
  //     successCallback: async res => {
  //       console.log("Got the booking data here : ", res.data.data);
  //       this.props.doctorAppointmentData(res.data.data);
  //       this.setState({
  //         bookingData: res.data.data
  //       });
  //       if (res.data.data.directCall) {
  //         this.directCallAllowed();
  //       } else {
  //         let fiveMinutes = 60 * 5;
  //         this.startTimer(fiveMinutes);
  //       }
  //     },
  //     failureCallback: err => {
  //       console.log("Something went wrong. Please try again : ", err);
  //     },
  //     showPopUp: false
  //   };
  //   this.setState({
  //     apiCall: apiCallParam
  //   });
  // };

  // show device issue popup on timeout
  showDeviceIssuePopupOnTimeout = () => {
    this.props.saveTimerStatus(true);

    this.setState({
      patientDeviceIssuePopup: true
    });

    clearInterval(this.clearTimer);
  };

  handleOkayPatientDeviceIssuePopup = () => {
    this.setState({
      patientDeviceIssuePopup: false
    });

    this.resetVariables();
    this.props.saveTimerStatus(false);

    let _this = this;

    this.changeDoctorBusyStatusWithCallBack(false, function () {
      _this.props.history.push(appRoutes.dashboard);
    });
  };

  // change doctor state to busy in backend and in store which will reflect in this application
  changeDoctorState = () => {
    let bodyData = new FormData();
    bodyData.append("isBusy", false);

    let apiCallParam = {
      reqType: "PUT",
      reqURL: changeDoctorBusyState,
      dataObj: bodyData,
      params: {},
      headers: {},
      successCallback: res => { },
      failureCallback: err => { },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParam
    });
  };

  // change doctor busy state with callback
  changeDoctorBusyStatusWithCallBack = (changeState, callback) => {
    let bodyDataDoctorState = new FormData();
    bodyDataDoctorState.append("isBusy", changeState);
    let apiCallParamDoctorState = {
      reqType: "PUT",
      reqURL: changeDoctorBusyState,
      dataObj: bodyDataDoctorState,
      params: {},
      headers: {},
      successCallback: async res => {
        //this.props.commonReducers.doctorOnlineState = !changeState;
        callback(null, res);
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again : ", err);
        callback(err, null);
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParamDoctorState
    });
  };

  // 5 minute timer
  startTimer = duration => {
    this.setState({
      hideCallBtn: false // show timer and call button
    });

    let start = Date.now(),
      diff,
      minutes,
      seconds,
      _this = this;
    function timer10() {
      // get the number of seconds that have elapsed since
      // startTimer() was called
      diff = duration - (((Date.now() - start) / 1000) | 0);

      if (diff > 0) {
        _this.setState({
          hideCallBtn: false // show timer and call button
        });

        // does the same job as parseInt truncates the float
        minutes = (diff / 60) | 0;
        seconds = diff % 60 | 0;

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        _this.setState({
          timer: minutes + ":" + seconds // set minute and seconds
        });
      } else if (diff <= 0) {
        // _this.setState({
        //   hideCallBtn: true // hide timer and call button
        // });
        // _this.showDeviceIssuePopupOnTimeout();
      }
    }
    //timer10();
    //this.clearTimer = setInterval(timer10, 1000);
  };

  // handeling video call offer
  handleAllMsg = data => {
    console.log("Handeling Message in Doctor *********** : ", data);
    switch (data.type) {
      case "answer":
        console.log("Answer : ", data);
        this.handleAnswer(data.answer);
        break;
      //when a remote peer sends an ice candidate to us
      case "candidate":
        console.log("HandleCandidate: ", data);
        this.handleCandidate(data.candidate);
        break;
      case "leave":
        console.log("Handle leave");
        // this.handleLeave();
        break;
      case "initiateVideoCall":
        if (initiateVideoCall === false) {
          initiateVideoCall = true;
          this.initiaVideoCallNow(data);
        }
        break;
      case "initiateVideoAgain":
        if (initiateVideoCall === false) {
          initiateVideoCall = true;
          this.initiaVideoCallNow(data);
        }
        break;
      default:
        console.log("Nothing matched");
        break;
    }
  };

  initiaVideoCallNow = data => {
    console.log(
      "------------ I'm in initiate Video Call now event ----------- ",
      data
    );
    this.setState({
      callingPatientPopupState: false,
      pleaseWait: false,
      // acceptedCallByPatient: data.data
      acceptedCallByPatient: data
    });
    this.startLocalVideo(() => {
      console.log("*********************** Call Back **********************");
      console.log("Now calling to patient : ", this.state.callRequestData);
      // let callToUsername = this.state.callRequestData.data.data.patientId,
      // _this = this;
      let _this = this;

      // console.log("Calling to this patient : ", callToUsername);

      // if (callToUsername && callToUsername.length > 0) {
      //   connectedUser = callToUsername;

      //   if (yourConn) {
      //     // create an offer
      //     console.log("NOw creating a offer");
      //     yourConn.createOffer(
      //       function(offer) {
      //         send({
      //           type: "offer",
      //           offer: offer,
      //           appointmentId: _this.state.bookingData._id,
      //           from: "doctor"
      //         });
      //         console.log("Offer sent");
      //         yourConn.setLocalDescription(offer);
      //       },
      //       function(error) {
      //         alert("Error when creating an offer");
      //       }
      //     );
      //   }
      // }

      if (yourConn) {
        // create an offer
        console.log("NOw creating a offer");
        // yourConn.createOffer(
        //   function (offer) {
        //     send({
        //       type: "offer",
        //       offer: offer,
        //       appointmentId: _this.state.bookingData._id,
        //       from: "doctor"
        //     });
        //     console.log("Offer sent");
        //     yourConn.setLocalDescription(offer);
        //   },
        //   function (error) {
        //     alert("Error when creating an offer");
        //   }
        // );

        // Ipad safari support
        yourConn.createOffer({
          offerToReceiveAudio: 1,
          offerToreceiveVideo: 1
        }).then(_this.gotDescriptionLocal, _this.onCreateSessionDescriptionError);
      }
    });
  };

  gotDescriptionLocal = (desc) => {
    console.log('Offer from local \n' + desc.sdp);
    let _this = this;
    yourConn.setLocalDescription(desc).then(
      () => {
        send({
          type: "offer",
          offer: desc,
          appointmentId: _this.state.bookingData._id,
          from: "doctor"
        });
        console.log("Offer sent");
      }, this.onSetSessionDescriptionError
    );
  };

  onCreateSessionDescriptionError = (error) => {
    console.log('Failed to create session description: ' + error.toString());
  }

  //when we got an answer from a remote user
  handleAnswer = answer => {
    // // try {
    // // let  peerAns = (new RTCSessionDescription(answer));
    // // yourConn.setRemoteDescription(peerAns);

    // console.log("Now handeling answer here");

    // yourConn.setRemoteDescription(
    //   new RTCSessionDescription(answer),
    //   () => {
    //     console.log("Setting remote description by answer");
    //   },
    //   e => {
    //     console.log("Got some error here in setting remote description :: ", e);
    //   }
    // );
    // // } catch (err) {
    // //   console.log("Error in handeling anser - doctor");
    // // }

    // Added IPAD Safari Support now
    yourConn.setRemoteDescription(answer).then(() => {
      console.log("Remote answer set by doctor from patient");
    }).catch((e) => {
      console.log("error in handleAnswer(): ", e);
    });
  };

  //when we got an ice candidate from a remote user
  handleCandidate = async candidate => {
    // setTimeout(function() {
    // yourConn.addIceCandidate(new RTCIceCandidate(candidate));
    yourConn.addIceCandidate(candidate).catch(e => {
      console.log("Failure during addIceCandidate(): " + e.name);
    });
    // }, 5000);
    // if (candidate) {
    //   yourConn.addIceCandidate(new RTCIceCandidate(candidate));
    // }
  };

  // call to patient event
  handleCallEvent = () => {
    // call button disabled when user pressed CALL ones
    this.setState({
      callBtnDisable: true,
      hideCallBtn: true,
      doctorDisconnectedCall: false,
      disableConsultCallBtn: true
    });

    clearInterval(this.clearTimer);

    let bodyDataAppointment = new FormData();
    bodyDataAppointment.append(
      "appointmentId",
      this.state.callRequestData.data.data.appointmentId
    );

    let apiCallParamChangeAppointment = {
      reqType: "POST",
      reqURL: changeAppointmentStatus,
      dataObj: bodyDataAppointment,
      params: {},
      headers: {},
      successCallback: async res => {
        console.log("Appointment state changed : ", res);
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again : ", err);
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParamChangeAppointment
    });

    if (this.state.bookingData.directCall) {
      console.log("Direct call now");
      console.log("Nothing to do here, we just wait for initiate video call event");
      // this.startLocalVideo(() => {
      //   console.log(
      //     "*********************** Direct call - Start video **********************"
      //   );
      //   console.log("Now calling to patient : ", this.state.callRequestData);
      //   console.log("this.state.bookingData : ", this.state.bookingData);
      //   let callToUsername = this.state.bookingData.patientId._id,
      //     _this = this;

      //   console.log("Calling to this patient : ", callToUsername);

      //   if (callToUsername.length > 0) {
      //     connectedUser = callToUsername;

      //     if (yourConn) {
      //       // create an offer
      //       console.log("NOw creating a offer");
      //       yourConn.createOffer(
      //         function(offer) {
      //           send({
      //             type: "offer",
      //             offer: offer,
      //             appointmentId: _this.state.bookingData._id,
      //             from: "doctor"
      //           });
      //           console.log("Offer sent");

      //           yourConn.setLocalDescription(offer);
      //         },
      //         function(error) {
      //           alert("Error when creating an offer");
      //         }
      //       );
      //     }
      //   }
      // });
    } else {
      let bodyDataMakeACall = new FormData();
      bodyDataMakeACall.append(
        "appointmentId",
        this.state.callRequestData.data.data.appointmentId
      );
      bodyDataMakeACall.append("deviceType", "2"); // change here later when completely remove deviceType
      bodyDataMakeACall.append(
        "deviceToken",
        "a3032435-e665-4118-aaca-7aec9531c96e"
      ); // change here later when completely remove deviceToken

      let apiCallParamMakeACall = {
        reqType: "POST",
        reqURL: makeACall,
        dataObj: bodyDataMakeACall,
        params: {},
        headers: {},
        successCallback: async res => {
          console.log("Make a call API called here : ", res);
          this.setState({
            callBtnDisable: false,
            callingPatientPopupState: true
          });
          setTimeout(() => {
            this.setState({
              callingPatientPopupState: false,
              pleaseWait: false
            });
          }, 40000);
          console.log(
            "Here we will get session id : ",
            res.data.data.sessionId
          );
          this.props.saveSessionId(res.data.data.sessionId);
          this.setState({
            sessionId: res.data.data.sessionId
          });
          console.log("Now create timer");
        },
        failureCallback: err => {
          console.log(err);

          if (
            err.statusCode === 400 &&
            err.message === "The Consult Request has been cancelled by Patient"
          ) {
            setTimeout(this.handleFailMakeACall, 3000, true);
          } else {
            setTimeout(this.handleFailMakeACall, 3000, false);
          }
        },
        showPopUp: false,
        redirectURL: appRoutes.dashboard,
        showErrPopUp: false
      };
      this.setState({
        apiCall: apiCallParamMakeACall
      });
    }
  };

  handleFailMakeACall = (doNavigation = false) => {
    this.setState({
      callBtnDisable: true,
      hideCallBtn: true,
      disableConsultCallBtn: true
    });

    this.changeDoctorBusyStatusWithCallBack(false, (err, data) => {
      if (doNavigation === true) {
        if (err) console.log("Something went wrong, Please try again ! ", err);
        else {
          console.log("Make A Call Error: ", err);
          this.setState({
            callBtnDisable: false,
            callingPatientPopupState: false,
            pleaseWait: false
          });
          this.resetVideoCallReduxState();
          this.goToDashboard();
        }
      }
    });
  };

  startRemoteVideoTimerCount = () => {
    console.log("Starting remote Video Timer count");
    this.setState({
      remoteVideoTimerCountAfterLocalVideo: setTimeout(
        this.addIssueWithPatientDeviceOnCall,
        15000
      )
    });
  };

  // start local video
  startLocalVideo = callback => {
    let _this = this;

    let _appointmentId = null;
    if (
      this.state.callRequestData &&
      this.state.callRequestData.data.data.appointmentId
    )
      _appointmentId = this.state.callRequestData.data.data.appointmentId;
    else _appointmentId = this.state.bookingData._id;

    _this.setState({
      showVideoContainer: true,
      pleaseWait: false,
      disableConsultCallBtn: true
    });

    console.log("showVideoContainer: ", _this.state.showVideoContainer, this.state.showVideoContainer);

    // navigator.getUserMedia =
    //   navigator.mediaDevices ||
    // navigator.getUserMedia ||
    //   navigator.webkitGetUserMedia ||
    //   navigator.mozGetUserMedia;

    navigator.mediaDevices.getUserMedia(
      { video: true, audio: true }).then((myStream) => {

        stream = myStream;

        // //displaying local video stream on the page
        // let video = document.querySelector("#localVideo");
        // video.load();
        // video.srcObject = new MediaStream(stream);
        // video.onloadedmetadata = function (e) {
        //   video.play();
        // };

        // displaying local video stream on the page - ipad support
        const localVideo = document.querySelector('#localVideo');
        const videoTracks = myStream.getVideoTracks();
        console.log('Received local stream');
        console.log('Got stream with constraints: video audio true');
        console.log(`Using video device: ${videoTracks[0].label}`);
        let localStream = myStream;
        localVideo.srcObject = myStream;
        localVideo.play();
        localStream.getTracks().forEach(track => {
          console.log("Local Stream Tracks: ", track);
          yourConn.addTrack(track, localStream);
        });
        console.log('Adding Local Stream to peer connection');

        // setup stream listening
        // yourConn.addStream(stream);

        _this.startRemoteVideoTimerCount();

        //when a remote user adds stream to the peer connection, we display it
        // yourConn.onaddstream = function (e) {
        //   let video2 = document.querySelector("#remoteVideo");
        //   video2.load();
        //   video2.srcObject = new MediaStream(e.stream);
        //   video2.onloadedmetadata = function (e) {
        //     video2.play();
        //     _this.startVideoTimer();
        //     _this.setState({
        //       callingPatientPopupState: false,
        //       pleaseWait: false
        //     });
        //     clearInterval(_this.clearTimer);
        //     clearTimeout(_this.state.remoteVideoTimerCountAfterLocalVideo);
        //   };
        // };
        yourConn.ontrack = (e) => {
          console.log("--------- On Add Stream --------------- ", e.streams);
          const remoteVideo = document.querySelector('#remoteVideo');
          console.log("remote video element: ", remoteVideo);
          // let remoteStream = e.stream[0];
          // remoteVideo.srcObject = e.stream[0];
          if (remoteVideo.srcObject !== e.streams[0]) {
            console.log(e, e.stream, e.streams);
            remoteVideo.load();
            remoteVideo.srcObject = new MediaStream(e.streams[0]);
            var remoteVideoPromise = remoteVideo.play();
            console.log("Remote Video Promise: ", remoteVideoPromise);
            remoteVideoPromise.then((_) => {
              console.log("Remote Video Working");
              remoteVideo.play();
            }).catch((error) => {
              console.log("Remote Video error");
            })
            console.log('Received remote stream');
          }
          _this.startVideoTimer();
          _this.setState({
            callingPatientPopupState: false,
            pleaseWait: false
          });
          clearInterval(_this.clearTimer);
          clearTimeout(_this.state.remoteVideoTimerCountAfterLocalVideo);
        };

        console.log(
          "********** Before Candidate Generation **********************"
        );
        console.log(yourConn);

        // setTimeout(_this.handleIceCandidateForConnection, 4000);

        // // Setup ice handling
        yourConn.onicecandidate = function (event) {
          console.log("Asking for iceCandidate: ", event);
          if (event.candidate) {
            send({
              type: "candidate",
              candidate: event.candidate,
              appointmentId: _appointmentId,
              from: "doctor"
            });
          }
        };

        console.log(
          "********** After start local video finish **********************"
        );
        console.log(yourConn);

        callback();
      }).catch(e => alert('getUserMedia() error: ' + e.name));
      // function (error) {
      //   console.log(error);
      // }
    // );
  };

  // handleIceCandidateForConnection = () => {
  //   console.log("*********** Inside handleIceCandidateForConnection **********************");
  //   let _appointmentId = null;
  //   if (
  //     this.state.callRequestData &&
  //     this.state.callRequestData.data.data.appointmentId
  //   )
  //     _appointmentId = this.state.callRequestData.data.data.appointmentId;
  //   else _appointmentId = this.state.bookingData._id;

  //   console.log("Ice candidate send event below here: ");

  //   console.log("YOur Connection : ", yourConn);

  //   // Setup ice handling
  //   yourConn.onicecandidate = event => {
  //     console.log("Asking for iceCandidate: ", event);
  //     if (event.candidate) {
  //       send({
  //         type: "candidate",
  //         candidate: event.candidate,
  //         appointmentId: _appointmentId,
  //         from: "doctor"
  //       });
  //     }
  //   };
  // };

  // handle Microphone voice to mute and unmute
  handleMicrophone = status => {
    if (stream) {
      stream.getTracks().forEach(track => {
        console.log("Tracks are here : ", track.kind == "audio");
        if (track.kind == "audio") {
          track.enabled = status;
          this.setState({
            audioAllow: status
          });
        }
      });
    } else {
      console.log("Video not found");
    }
  };

  // handle Microphone video to display and hide
  handleVideo = status => {
    if (stream) {
      stream.getTracks().forEach(track => {
        console.log("Tracks are here : ", track.kind == "audio");
        if (track.kind == "video") {
          track.enabled = status;
          this.setState({
            videoAllow: status
          });
        }
      });
    } else {
      console.log("Video not found");
    }
  };

  // ask for end call
  askForEndCall = () => {
    this.setState({
      endVideoCallPopUp: true
    });
  };

  closeVideoCallScreen = () => {
    let appointmentIdToSend = "";
    if (this.state.bookingData) {
      appointmentIdToSend = this.state.bookingData._id;
    } else {
      appointmentIdToSend = this.state.acceptedCallByPatient.data.appointmentId;
    }

    let apiCallParam = {
      reqType: "GET",
      reqURL: closeVideoCallScreenApiRoute,
      dataObj: {},
      params: {
        appointmentId: appointmentIdToSend,
        patientId: this.state.bookingData
          ? this.state.bookingData.patientId._id
          : ""
      },
      headers: {},
      successCallback: async res => {
        console.log("Video Close API CALL DONE.");
      },
      failureCallback: err => {
        console.log("Video Close API CALL ERROR : ", err);
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParam
    });

    clearInterval(this.state.timernew);
    clearInterval(this.clearTimer);
    this.setState({
      callBtnDisable: true, // disable the call button upon first attemp
      hideCallBtn: true,
      disableConsultCallBtn: true,
      videoCallTimer: false,
      timernew: 0,
      timernewvalue: 0,
      videoTimerValue: null,
      endVideoCallPopUp: false,
      showVideoContainer: false, // hide draggable video container,
      pleaseWait: false, // hide please wait popup
      patientDisconnected: false // in case if patient disconnected and we try to call again,
    });

    if (stream) {
      stream.getTracks().forEach(track => {
        console.log("Stopping video now");
        track.stop();
      });
    }

    connectedUser = null;
    let remoteVideoEle = document.querySelector("#remoteVideo");
    if (remoteVideoEle) remoteVideoEle.srcObject = null;

    let localVideoEle = document.querySelector("#localVideo");
    if (localVideoEle) localVideoEle.srcObject = null;

    yourConn.onicecandidate = null;
    yourConn.onaddstream = null;
  };

  // handle video call
  handleEndVideoCall = () => {
    this.setState({
      isLoading: true, // show loader until get responce from endDoctroCall API
      showVideoContainer: false, // hide draggable video container,
      patientDisconnected: false, // in case if patient disconnected and we try to call again,
      doctorDisconnectedCall: true // doctor ended call successfully - no poor internet problem
    });
    console.log("Now ending call here");
    initiateVideoCall = false;
    patientAcceptedCall = false;
    if (stream) {
      stream.getTracks().forEach(track => {
        console.log("Stopping video now");
        track.stop();
      });
    }
    send({
      type: "leave",
      appointmentId: this.state.bookingData._id,
      from: "doctor"
    });

    this.handleLeave();
  };

  // end call will reset everything
  handleLeave = () => {
    initiateVideoCall = false;
    patientAcceptedCall = false;
    if (stream) {
      stream.getTracks().forEach(track => {
        console.log("Stopping video now");
        track.stop();
      });
    }

    this.remoteVideoRef.current.removeEventListener('leavepictureinpicture', pictureInPictureLeaveEvent);

    connectedUser = null;
    // remoteVideo.src = null;
    let remoteVideoEle = document.querySelector("#remoteVideo");
    if (remoteVideoEle) remoteVideoEle.srcObject = null;

    let localVideoEle = document.querySelector("#localVideo");
    if (localVideoEle) localVideoEle.srcObject = null;

    // yourConn.close();
    yourConn.onicecandidate = null;
    yourConn.onaddstream = null;

    this.setState({
      endVideoCallPopUp: false
    });

    this.endTimerPatient();

    // this.changeDoctorBusyStatusWithCallBack(false, (err, result) => {
    //   if (err) {
    //     console.log("Something went wrong !, please try again. ", err);
    //   } else {
    //     this.endTimerPatient(); // first API for disconnect the call
    //   }
    // });
  };

  endTimerPatient = () => {
    console.log("End time data: ", this.state.acceptedCallByPatient);

    // let appointmentId = this.state.bookingData
    //   ? this.state.bookingData._id
    //   : "";

    // if (this.state.acceptedCallByPatient !== null) {
    //   appointmentId = this.state.acceptedCallByPatient.data.appointmentId;
    // }
    let appointmentId = "";
    if (this.state.bookingData) {
      appointmentId = this.state.bookingData._id;
    } else {
      appointmentId = this.state.acceptedCallByPatient.data && this.state.acceptedCallByPatient.data.appointmentId ? this.state.acceptedCallByPatient.data.appointmentId : "";
    }


    let endTimerPatientData = new FormData();
    endTimerPatientData.append("appointmentId", appointmentId);

    let sessionId = null;

    if (this.state.sessionId) sessionId = this.state.sessionId;
    else sessionId = this.props.commonReducers.sessionId;

    endTimerPatientData.append("sessionId", sessionId);

    // endTimerPatientData.append(
    //   "sessionId",
    //   this.props.commonReducers.sessionId
    //   // this.state.acceptedCallByPatient.data.sessionId
    // );

    let apiCallParam = {
      reqType: "PUT",
      reqURL: endTimerPatientCall,
      dataObj: endTimerPatientData,
      params: {},
      headers: {},
      successCallback: async res => {
        console.log("1st API Done, Now End Call from doctor");
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again : ", err);
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParam
    });
    this.cancelEndVideoCall();
    this.disconnectCall();
  };

  cancelEndVideoCall = () => {
    this.setState({
      endVideoCallPopUp: false
    });
  };

  disconnectCall = () => {
    // let appointmentId = this.state.bookingData
    //   ? this.state.bookingData._id
    //   : "";

    // if (this.state.acceptedCallByPatient !== null) {
    //   appointmentId = this.state.acceptedCallByPatient.data.appointmentId;
    // }

    let appointmentId = "";
    if (this.state.bookingData) {
      appointmentId = this.state.bookingData._id;
    } else {
      appointmentId = this.state.acceptedCallByPatient.data && this.state.acceptedCallByPatient.data.appointmentId ? this.state.acceptedCallByPatient.data.appointmentId : "";
    }

    clearInterval(this.state.consultTimerInterval);
    clearInterval(this.state.timernew);
    this.setState({
      consultTimerStatus: false,
      consultTimerInterval: null,
      videoCallTimer: false,
      timernew: null
    });

    let _this = this;

    setTimeout(() => {
      let data = new FormData();
      data.append("appointmentId", appointmentId);

      let sessionId = null;
      if (this.state.sessionId) sessionId = this.state.sessionId;
      else sessionId = this.props.commonReducers.sessionId;

      data.append("sessionId", sessionId);
      // data.append("sessionId", this.state.acceptedCallByPatient.data.sessionId);
      // data.append("sessionId", this.props.commonReducers.sessionId);
      data.append("callStatus", "COMPLETE");

      if (
        this.state.bookingData &&
        this.state.bookingData.directCall === false
      ) {
        data.append("endCallTime", this.state.consultTimerStartPoint);
      } else {
        data.append("endCallTime", this.state.timernewvalue);
      }

      let apiCallParam = {
        reqType: "PUT",
        reqURL: endCallByDoctor,
        dataObj: data,
        params: {},
        headers: {},
        successCallback: async res => {
          console.log("End call success");
          _this.setState({
            isLoading: false,
            paymentReceiptReceivedOnEndCallContent:
              "You have ended the video call for Consult ID: " +
              this.state.bookingData.appointmentId,
            paymentReceiptReceivedOnEndCallState: true,
            consultSummaryId: res.data.data
          });
          console.log(
            "****************** Already set the state ************************"
          );
          if (stream) {
            stream.getTracks().forEach(track => {
              console.log("Stopping video now");
              track.stop();
            });
          }
          // this.goToConsultSummaryOnEndCall(res.data.data);
          // this.changeDoctorBusyStatusWithCallBack(false, (err, result) => {
          //   this.resetVideoCallReduxState();
          //   this.goToDashboard();
          // });
        },
        failureCallback: err => {
          console.log("End call fail");
          console.log("Something went wrong. Please try again : ", err);
          this.setState({
            isLoading: false
          });
          this.changeDoctorBusyStatusWithCallBack(false, (err, result) => {
            this.resetVideoCallReduxState();
            this.goToDashboard();
          });
        },
        showPopUp: false
      };
      this.setState({
        apiCall: apiCallParam
      });
    }, 3000);
  };

  goToConsultSummaryOnEndCall = () => {
    this.changeDoctorBusyStatusWithCallBack(false, (err, result) => {
      this.props.doctorAppointmentData(null);
      this.setState({
        paymentReceiptReceivedOnEndCallState: false
      });
      this.resetVideoCallReduxState();
      const { history } = this.props;
      if (history)
        history.push(
          appRoutes.consultHistoryView + "/" + this.state.consultSummaryId,
          { _id: this.state.consultSummaryId }
        );
    });
  };

  // Video Call timer when peer video connected
  startVideoTimer = state => {
    console.log("TImer start");
    send({
      type: "videoTimerStatus",
      timerStatus: "play",
      appointmentId: this.state.bookingData._id,
      from: "doctor"
    });
    this.setState({
      videoCallTimer: state
    });
    let startTimer = this.state.timernewvalue;
    startTimer++;
    console.log("Start timer : ", startTimer);
    let d = Number(startTimer),
      h = Math.floor(d / 3600),
      m = Math.floor((d % 3600) / 60),
      s = Math.floor((d % 3600) % 60),
      hDisplay = h > 0 ? h + (h === 1 ? " hour : " : " hours : ") : "",
      mDisplay = m > 0 ? m + (m == 1 ? " min : " : " mins : ") : "",
      sDisplay = s > 0 ? s + (s == 1 ? " sec" : " secs") : "";

    this.setState({
      videoTimerValue: hDisplay + mDisplay + sDisplay
    });

    this.setState({
      timernew: setInterval(() => {
        if (this.state.timernew !== null) {
          startTimer++;
          let d = Number(startTimer),
            h = Math.floor(d / 3600),
            m = Math.floor((d % 3600) / 60),
            s = Math.floor((d % 3600) % 60);
          let hDisplay = h > 0 ? h + (h === 1 ? " hour : " : " hours : ") : "";
          let mDisplay = m > 0 ? m + (m == 1 ? " min : " : " mins : ") : "";
          let sDisplay = s > 0 ? s + (s == 1 ? " sec" : " secs") : "";
          this.setState({
            videoTimerValue: hDisplay + mDisplay + sDisplay,
            timernewvalue: startTimer
          });

          this.props.saveVideoCallData({
            timerVal: startTimer
          });
        }
      }, 1000)
    });
  };

  // pause video call timer
  stopVideoTimer = state => {
    console.log("timer paused");
    send({
      type: "videoTimerStatus",
      timerStatus: "pause",
      appointmentId: this.state.bookingData._id
    });
    clearInterval(this.state.timernew);

    this.setState({
      videoCallTimer: state,
      timernew: null
    });
  };

  goToDashboard = () => {
    const { history } = this.props;
    this.resetVideoCallReduxState();
    if (history) history.push(appRoutes.dashboard);
  };

  // patient rejected consult request from doctor when doctor called to patient
  // handlePatientRejectedVideoCallFromDoctor = () => {
  //   this.setState({
  //     callingPatientPopupState: false,
  //     patientRejectedVideoCallFromDoctorState: false
  //   });
  //   this.changeDoctorBusyStatusWithCallBack(false, (err, res) => {
  //     if (err) console.log("Something went wrong, Please try again ! ", err);
  //     else {
  //       this.goToDashboard();
  //       this.resetVideoCallReduxState();
  //     }
  //   });
  // };

  // handle video container size
  handleWindowSize = state => {
    this.setState({
      videoContainerMinimize: state,
      videoContainerPosition: state ? { x: 105, y: 130 } : { x: 0, y: 0 }
    });
  };

  // handle patient disconnected event
  handlePatientDisconnectedRetry = () => {
    console.log("Re connecting ...");
    this.handleCallEvent();
  };

  resetVideoCallReduxState = () => {
    initiateVideoCall = false;
    patientAcceptedCall = false;
    clearInterval(this.clearTimer);
    this.props.saveVideoCallData({
      isCallAccepted: false,
      timerVal: 0,
      isCallConnected: false
    });
    this.props.doctorAppointmentData(null);
    this.props.saveSessionId(null);
  };

  openUrl = url => {
    window.open(url, "_blank");
  };

  // for picture in picture mode
  enablePictureInPicture = () => {
    const video = document.querySelector("#remoteVideo");
    if (document.pictureInPictureElement) {
      document.exitPictureInPicture().catch(error => {
        // Error handling
        console.log("Error in picrue in picture : ", error);
      });
    } else {
      video.requestPictureInPicture().catch(error => {
        // Error handling
        console.log("2nd error in picture in picture : ", error);
      });
    }
  };

  // open PMS
  setSelectedPatient = () => {
    const auth = this.props.userData;
    const patientData = this.state.bookingData.patientId;
    window.open(
      APP_CONSTANTS.pmsURL +
      "/patient/patientDetails?accessToken=" +
      auth.accessToken +
      "&patientId=" +
      patientData._id +
      "&searchType=DOCTOR" +
      "&adminName=" +
      patientData.firstName +
      " " +
      patientData.lastName,
      "_blank"
    );
  };

  // direct call allowed - Call from PMS
  directCallAllowed = () => {
    this.handleCallEvent();
  };

  // if patient disconnected somehow or remote video is not connected until 10 sec
  addIssueWithPatientDeviceOnCall = () => {
    if (this.props.commonReducers.appointmentData) {
      console.log(
        "@@@@@@@@@@@@@@@@ Sending Video Connect Attempt from iceCandidate @@@@@@@@@@@@@@@@@@"
      );
      let dataToSend = {
        type: "videoConnectAttempt",
        appointmentId: this.props.commonReducers.appointmentData._id,
        from: "patient"
      };
      console.log("Sending attempt data: ", dataToSend);
      send(dataToSend);
    }
  };

  addIssueWithDoctorDeviceOnCall = () => {
    if (this.props.commonReducers.appointmentData) {
      console.log(
        "@@@@@@@@@@@@@@@@ Sending Video Connect Attempt from iceCandidate @@@@@@@@@@@@@@@@@@"
      );
      let dataToSend = {
        type: "videoConnectAttempt",
        appointmentId: this.props.commonReducers.appointmentData._id,
        from: "doctor"
      };
      console.log("Sending attempt data: ", dataToSend);
      send(dataToSend);
    }
  };

  // handle missed call by patient
  handlePatientCallNoPickup = data => {
    let _this = this;
    if (patientAcceptedCall === false) {
      this.setState({
        patientDeviceIssueContent:
          "Video call connection unsuccessful<br/>Please attempt to phone call the patient", //data.data.contents.en,
        patientDeviceIssueState: true,
        pleaseWait: false
      });
    }

    setTimeout(() => {
      if (initiateVideoCall === false && patientAcceptedCall === true) {
        _this.setState({
          patientDeviceIssueState: true,
          patientDeviceIssueContent: "Video call connection unsuccessful<br/>Please attempt to phone call the patient", //data.data.contents.en,
          pleaseWait: false,
        });
      }
    }, 10000);

  };

  patientDeviceIssue = () => {
    this.setState({
      patientDeviceIssueState: false
    });
  };

  copyClickedText = () => {
    console.log("Now copy the text");
    try {
      let _this = this;
      const copyText = this.state.bookingData.selectedCovidSituation ? this.state.bookingData.selectedCovidSituation.replace('declared', 'confirmed') : 'Private Consult';
      navigator.clipboard.writeText(copyText).then(() => {
        console.log('Copying to clipboard was successful!');
        this.setState({
          copyTextToolTip: true
        });
        setTimeout(() => {
          _this.setState({
            copyTextToolTip: false
          });
        }, 2000);
      }, function (err) {
        console.error('Could not copy text: ', err);
      });

    } catch (e) {
      console.log("Error In Copy Text: ", e);
    }
  }

  toggleHoverToolTip = () => {
    this.setState({
      copyTextHoverToolTip: !this.state.copyTextHoverToolTip
    })
  }

  showCancelConsultPopup = () => {
    this.setState({
      cancelConsultReason: "",
      showCancelConsultPopup: true
    });
  }

  closeCancelConsultPopup = () => {
    this.setState({
      showCancelConsultPopup: false
    });
  }

  cancelConsult = () => {
    if (this.state.cancelConsultReason === "") {
      this.setState({
        cancelConsultReasonError: true
      });
      return;
    } else {
      this.setState({
        cancelConsultReasonError: false
      });
    }
    this.setState({
      apiCall: {
        reqType: "POST",
        reqURL: cancelCallByDoctor,
        dataObj: {
          reasonForCancellation: this.state.cancelConsultReason,
          appointmentId: this.state.bookingData?._id || this.state.appointmentData?._id
        },
        params: {},
        headers: {},
        successCallback: async () => {

          await this.safetyCheckCamera();
          await this.resetVariables();

          await this.props.doctorAppointmentData(null);
          await this.closeCancelConsultPopup();

          const { history } = this.props;
          if (history)
            history.replace(
              appRoutes.dashboard,
              {}
            );
        },
        failureCallback: console.error,
        showPopUp: true
      }
    });
  }

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition, controlledPosition } = this.state;

    return (
      <div className="row rounded p-3 call-request-accepted">
        <div className="w-auto m-auto ml-5 header-row-setting-accept-appointment">
          <img
            src={
              this.state.bookingData &&
                this.state.bookingData.patientId.profilePic.original
                ? this.state.bookingData.patientId.profilePic.original
                : DefaultPic
            }
            alt="patient_url"
            className="request-patient-profile-pic"
          />
        </div>
        <div
          className="w-auto m-auto ml-5 cursor-pointer external-link-pms-div header-row-setting-accept-appointment pt-4"
          onClick={() => this.setSelectedPatient()}
        >
          <i className="fas fa-external-link-alt ml-2 external-link-pms"></i>
          <Label
            className="secondary-font m-0 float-left cursor-pointer"
            title={
              this.state.bookingData
                ? this.state.bookingData.patientId.firstName +
                " " +
                this.state.bookingData.patientId.lastName
                : "-"
            }
          />
          <br />
          <Label className="secondary-font m-0 cursor-pointer" title="UIN: " />
          <Label
            className="gray p-0 m-0 ml-2 patient-info cursor-pointer"
            title={
              this.state.bookingData
                ? this.state.bookingData.patientId.patientId
                : "-"
            }
          />
        </div>
        {this.state.bookingData && this.state.bookingData.directCall === true && (
          <div className="w-auto m-auto ml-5 header-row-setting-accept-appointment pt-4">
            <Label
              title="Consult ID:"
              className="primary-color font-weight-bold pr-1"
            />
            <Label
              title={
                this.state.bookingData
                  ? " " + this.state.bookingData.appointmentId
                  : "-"
              }
              className="primary-color font-weight-bold"
            />
          </div>
        )}

        {/* <div
          className={
            this.state.hideCallBtn
              ? "d-none"
              : "w-auto m-auto ml-5 header-row-setting-accept-appointment pt-4"
          }
        >
          <Label
            title={"Call Patient Within "}
            className="m-0 secondary-font ml-2"
          />
          <br />
          <Label
            title={this.state.timer + " mins"}
            className="gray p-0 m-0 ml-2"
          />
        </div> */}
        {this.state.bookingData && this.state.bookingData.directCall === false && (
          <Fragment>
            <div className="w-auto m-auto header-row-setting-accept-appointment pt-4">
              <IconButton
                title="Video Call"
                className="doc-call-btn font-15"
                icon="fas fa-video"
                clickEvent={this.handleCallEvent}
                disabled={
                  this.state.hideCallBtn ||
                  this.state.callBtnDisable ||
                  (this.state.consultTimerStatus === true ? false : true) ||
                  this.state.disableConsultCallBtn
                }
              />
            </div>

            <div className="w-auto m-auto header-row-setting-accept-appointment pt-4">
              <IconButton
                title={this.state.phoneCallButtonWording}
                className={
                  !this.state.phoneCallButtonWording.includes("Phone Call")
                    ? "doc-call-btn dr-phone-call-btn font-15 text-switched-to-phone"
                    : "doc-call-btn dr-phone-call-btn font-15"
                }
                icon="fas fa-phone-alt"
                clickEvent={this.callPatientPhoneButtonClicked}
                disabled={
                  (this.state.disableConsultCallBtn === true ? false : true) ||
                  !this.state.phoneCallButtonWording.includes("Phone Call")
                }
              />
            </div>

            <div
              className="pt-4 d-flex flex-column justify-content-center align-items-center text-center consult-timer-container">
              <Label
                className="secondary-font m-0 cursor-pointer"
                title={
                  this.state.consultTimerStatus === false
                    ? "Start Timer"
                    : "Pause Timer"
                }
              />
              {this.state.consultTimerStatus === false && (
                <i
                  onClick={this.startConsultTimer}
                  className="fas fa-play consult-timer-play-btn"
                ></i>
              )}
              {this.state.consultTimerStatus === true && (
                <i
                  onClick={this.stopConsultTimer}
                  className="fas fa-pause consult-timer-stop-btn"
                ></i>
              )}
              <Label
                className="secondary-font m-0 cursor-pointer"
                title={this.state.consultTimerValue}
              />
            </div>

            <div className="w-auto m-auto header-row-setting-accept-appointment pt-4">
              <IconButton
                title="Complete Consult"
                className="doc-call-btn dr-complete-consult-btn font-15"
                clickEvent={this.askForEndCall}
                disabled={
                  this.state.disableConsultCallBtn === true ? false : true
                }
              />
            </div>

            {
              !this.state.disableConsultCallBtn && (

            <div className="w-auto m-auto header-row-setting-accept-appointment pt-4">
              <IconButton title="Cancel Consult"
                className="red doc-call-btn font-15"
                clickEvent={this.showCancelConsultPopup}
              />
            </div>
              )
            }
          </Fragment>
        )}

        <div className="col-sm-12 w-100 border-bottom mt-3"></div>
        <div className="col-sm-12 p-0 patient-attached-documents">
          <div className="card p-3 mt-2 custom-card">
            <div className="row mt-2">
              {/* <div className="col-sm-3 cursor-pointer external-link-pms-div">
                <i className="fas fa-external-link-alt ml-2 external-link-pms"></i>
                <Label
                  className="secondary-font m-0 float-left cursor-pointer"
                  title={
                    this.state.bookingData
                      ? this.state.bookingData.patientId.firstName +
                        " " +
                        this.state.bookingData.patientId.lastName
                      : "-"
                  }
                />
                <br />
                <Label
                  className="secondary-font m-0 cursor-pointer"
                  title="UIN: "
                />
                <Label
                  className="gray p-0 m-0 ml-2 patient-info cursor-pointer"
                  title={
                    this.state.bookingData
                      ? this.state.bookingData.patientId.patientId
                      : "-"
                  }
                />
              </div> */}
              <div className="col-sm-4">
                <Label
                  className="w-100 secondary-font m-0"
                  title="Nature of Consult"
                />
                <img
                  src={
                    this.state.bookingData && this.state.bookingData.patientId && this.state.bookingData.patientId.profilePic
                      ? this.state.bookingData.consultId.consultPic.original
                      : ""
                  }
                  alt="consult type"
                  className="consult-type-request"
                />
                <Label
                  className="gray p-0 m-0"
                  title={
                    this.state.bookingData
                      ? this.state.bookingData.consultId.consultName
                      : ""
                  }
                />
                {/* <Label
                  title={`Nature of Consult: ${
                    this.state.bookingData
                      ? this.state.bookingData.consultId.consultName
                      : "-"
                    }`}
                  className="w-100"
                /> */}
              </div>
              <div className="col-sm-8">
                <Label
                  className="w-100 secondary-font m-0 mb-1"
                  title="Billing"
                />

                {/* If No Bulk Bill then Show Private Consult */}
                {
                  this.state.bookingData && !this.state.bookingData.isBulkBilled ? <Fragment>
                    <div id="privateHoverTooltip">
                      <Label
                        className="gray p-0 m-0 cursor-pointer"
                        click={this.copyClickedText}
                        id="privateBilledTooltip"
                        title="Private Consult"
                      />
                      <UncontrolledTooltip placement="top" target="privateBilledTooltip" trigger="click" isOpen={this.state.copyTextToolTip}>
                        Text Copied
                      </UncontrolledTooltip>
                    </div>
                    <Tooltip placement="top" isOpen={this.state.copyTextHoverToolTip} autohide={false} target="privateHoverTooltip" toggle={this.toggleHoverToolTip}>
                      <i className="fa fa-clone" aria-hidden="true"></i>
                    </Tooltip>

                  </Fragment> : <Label
                    className="gray p-0 m-0"
                    title=""
                  />
                }

                {/* If Consult Is Bulk Billed then Show why accordently condition */}
                {
                  this.state.bookingData && this.state.bookingData.isBulkBilled ? (
                    <Fragment>
                      <div id="hoverTooltip">
                      <Label
                        className="gray p-0 m-0 cursor-pointer"
                        click={this.copyClickedText}
                        id="bulkBilledTooltip"
                        title={this.state.bulkBilledTextForCopy}
                      />
                      <UncontrolledTooltip placement="top" target="bulkBilledTooltip" trigger="click" isOpen={this.state.copyTextToolTip}>
                        Text Copied
                      </UncontrolledTooltip>
                      </div>
                      <Tooltip placement="top" isOpen={this.state.copyTextHoverToolTip} autohide={false} target="hoverTooltip" toggle={this.toggleHoverToolTip}>
                        <i className="fa fa-clone" aria-hidden="true"></i>
                      </Tooltip>
                    </Fragment>
                  ) : <Label
                    className="gray p-0 m-0"
                    title={``}
                  />
                }

              </div>
              {/* <div className={this.state.hideCallBtn ? "d-none" : "col-sm-3"}>
                <Label
                  title={"Call Patient within "}
                  className="m-0 secondary-font w-100"
                />
                <Label
                  title={this.state.timer + " mins"}
                  className="gray p-0 m-0"
                />
              </div> */}
              {/* <div className={this.state.hideCallBtn ? "d-none" : "col-sm-2"}>
                <IconButton
                  title="CALL"
                  className="small ml-3"
                  icon="fas fa-video"
                  clickEvent={this.handleCallEvent}
                  disabled={this.state.callBtnDisable}
                />
              </div> */}

              <div className="col-sm-12 mt-3">
                <Label
                  className="w-100 secondary-font m-0"
                  title="Images/Documents"
                />
              </div>

              <div className="col-sm-12">
                <Label
                  className={
                    this.state.bookingData &&
                      !this.state.bookingData.consultImgs.length &&
                      !this.state.bookingData.consultDocs.length
                      ? "w-100 m-0"
                      : "d-none"
                  }
                  title="No Images/Documents found"
                />
              </div>

              <div className="col-sm-12">
                <div className="row p-0 m-0">
                  {this.state.bookingData &&
                    this.state.bookingData.consultImgs.map((value, index) => {
                      return (
                        <div
                          className="float-left position-relative"
                          key={index}
                        >
                          {value.original.match(
                            /\.(jpeg|jpg|gif|png|jfif)$/
                          ) ? (
                            <img
                              src={value.original}
                              alt="no-img-instant-consult"
                              className="mt-2 mr-2 img-thumbnail att-fixed-size"
                            />
                          ) : (
                            <iframe
                              title="pdfFrame"
                              src={value.original}
                              alt="no-img-instant-consult"
                              className="mt-2 mr-2 img-thumbnail att-fixed-size"
                            />
                          )}
                          <i
                            className="fas fa-eye att-delete-btn cursor-pointer"
                            onClick={() => {
                              this.openUrl(value.original);
                            }}
                          />
                          <div className="clearfix" />
                        </div>
                      );
                    })}

                  {this.state.bookingData &&
                    this.state.bookingData.consultDocs.map((value, index) => {
                      return (
                        <div
                          className="float-left position-relative"
                          key={index}
                        >
                          {value.original.match(
                            /\.(jpeg|jpg|gif|png|jfif)$/
                          ) ? (
                            <img
                              src={value.original}
                              alt="no-img-instant-consult"
                              className="mt-2 mr-2 img-thumbnail att-fixed-size"
                            />
                          ) : (
                            <iframe
                              title="pdfFrame"
                              src={value.original}
                              alt="no-img-instant-consult"
                              className="mt-2 mr-2 img-thumbnail att-fixed-size"
                            />
                          )}
                          <i
                            className="fas fa-eye att-delete-btn cursor-pointer"
                            onClick={() => {
                              this.openUrl(value.original);
                            }}
                          />
                          <div className="clearfix" />
                        </div>
                      );
                    })}
                </div>
              </div>
              <div className="col-sm-12 mt-3">
                <Label
                  title="Additional Information"
                  className="secondary-font mt-2 w-100 m-0"
                />
                <Label
                  title={
                    this.state.bookingData &&
                      this.state.bookingData.consultInfo !== ""
                      ? this.state.bookingData.consultInfo
                      : "No additional information found"
                  }
                  className="w-100"
                />
              </div>
            </div>
          </div>
        </div>
        {/* <div className="col-sm-12 p-0">
          <div
            className={
              this.state.bookingData &&
              (this.state.bookingData.consultDocs.length ||
                this.state.bookingData.consultImgs.length ||
                this.state.bookingData.consultInfo)
                ? "card p-0 mt-2 custom-card"
                : "d-none"
            }
          >
            <div
              className={
                this.state.bookingData &&
                this.state.bookingData.consultImgs.length
                  ? "rows mt-2 pb-3"
                  : "d-none"
              }
            >
              <div className="col-sm-12">
                <Label
                  title="Attachments:"
                  className="secondary-font mt-3 w-100"
                />
                {this.state.bookingData &&
                  this.state.bookingData.consultImgs.map((value, index) => {
                    return (
                      <div
                        className="patient-images-consult p-0 mr-2 mt-2"
                        key={index}
                      >
                        <a href={value.original} target="_blank">
                          <img
                            src={value.original}
                            className="img-thumbnail attach-imgs"
                          />
                        </a>
                      </div>
                    );
                  })}
              </div>
            </div>
            <div
              className={
                this.state.bookingData &&
                this.state.bookingData.consultDocs.length
                  ? "rows mt-2 pb-3"
                  : "d-none"
              }
            >
              <div className="col-sm-12 mt-2">
                {this.state.bookingData &&
                  this.state.bookingData.consultDocs.map((value, index) => {
                    return (
                      <div
                        className="call-document-attached ml-0 mr-2 mt-2"
                        key={index}
                      >
                        <ButtonDropdown direction="down" className="w-100">
                          <Link
                            title={
                              value.original
                                .split(".")
                                .pop()
                                .toLowerCase() === "pdf"
                                ? "PDF"
                                : "Other"
                            }
                            href={value.original}
                            target="_blank"
                            className={
                              value.original
                                .split(".")
                                .pop()
                                .toLowerCase() === "pdf"
                                ? "consult-note-pdf-btn font-12"
                                : "consult-note-pdf-btn font-12 Other-doc"
                            }
                          />
                          <Button
                            id="caret"
                            title={`Document ${index + 1}`}
                            className="gray small pl-2 pr-0 m-0 text-left consult-note-btn font-12"
                            clickEvent={() => {
                              window.open(value.original, "_blank");
                            }}
                          />
                        </ButtonDropdown>
                      </div>
                    );
                  })}
              </div>
            </div>
            <div
              className={
                this.state.bookingData && this.state.bookingData.consultInfo
                  ? "rows mt-2"
                  : "d-none"
              }
            >
              <div className="col-sm-12">
                <Label
                  title="Consult Info:"
                  className="secondary-font mt-3 w-100"
                />
                <Label
                  title={
                    this.state.bookingData
                      ? this.state.bookingData.consultInfo
                      : "-"
                  }
                  className="w-100"
                />
              </div>
            </div>
          </div>
        </div> */}
        <Draggable
          handle="strong"
          defaultPosition={this.state.videoContainerPosition}
          {...dragHandlers}
        >
          <div
            className={
              this.state.showVideoContainer
                ? this.state.videoContainerMinimize
                  ? "box no-cursor video-container video-container-small"
                  : "box no-cursor video-container video-container-full"
                : "d-none"
            }
          >
            <div className="float-left">
              <p>{this.state.videoTimerValue}</p>
            </div>
            <strong className="cursor float-right cursor-pointer p-1">
              <div>
                <Button
                  id="maximiseVideo"
                  title="Maximise Video"
                  className={
                    this.state.videoContainerMinimize
                      ? "video-zoom-action mr-2"
                      : "d-none"
                  }
                  clickEvent={() => this.handleWindowSize(false)}
                />
                {/* <i
                  className={
                    this.state.videoContainerMinimize
                      ? "fas fa-window-maximize mr-2 cursor-pointer"
                      : "d-none"
                  }
                  onClick={() => this.handleWindowSize(false)}
                ></i> */}

                <Button
                  id="minimizeVideo"
                  title="Minimise Video"
                  className={
                    !this.state.videoContainerMinimize
                      ? "video-zoom-action mr-2"
                      : "d-none"
                  }
                  clickEvent={() => this.handleWindowSize(true)}
                />
                {/* <i
                  className={
                    !this.state.videoContainerMinimize
                      ? "fas fa-compress-arrows-alt mr-2 cursor-pointer"
                      : "d-none"
                  }
                  onClick={() => this.handleWindowSize(true)}
                ></i> */}
                <i
                  className={
                    !this.state.videoContainerMinimize
                      ? "d-none"
                      : "fas fa-arrows-alt cursor-pointer"
                  }
                ></i>
              </div>
            </strong>
            <div className="clearfix w-100"></div>
            <div className="row p-0 m-0">
              <div className="col-sm-4 p-2">
                <video
                  autoPlay={true}
                  id="localVideo"
                  muted
                  className={
                    this.props.commonReducers.appointmentData !== null &&
                      this.props.commonReducers.appointmentData.deviceDetails !==
                      undefined &&
                      this.props.commonReducers.appointmentData.deviceDetails
                        .device_model !== undefined &&
                      this.props.commonReducers.appointmentData.deviceDetails
                        .device_model !== "Macintosh" &&
                      this.props.commonReducers.appointmentData.deviceDetails
                        .device_model !== "Windows"
                      ? "doctor-mobile-video"
                      : "w-100"
                  }
                  playsinline
                ></video>
              </div>
              <div className="col-sm-8 p-2">
                <video
                  autoPlay={true}
                  id="remoteVideo"
                  className="w-100"
                  ref={this.remoteVideoRef}
                  playsinline
                  preload="none"
                ></video>
              </div>
              <div className="col-sm-12 text-left control-buttons">
                <span
                  className={
                    this.state.audioAllow
                      ? "ml-2 video-call-btn mircophone"
                      : "d-none"
                  }
                  onClick={() => this.handleMicrophone(false)}
                >
                  <i className="fas fa-microphone"></i>
                </span>
                <span
                  className={
                    !this.state.audioAllow
                      ? "ml-2 video-call-btn mircophone"
                      : "d-none"
                  }
                  onClick={() => this.handleMicrophone(true)}
                >
                  <i className="fas fa-microphone-slash"></i>
                </span>
                <span
                  className={
                    this.state.videoAllow
                      ? "ml-2 video-call-btn video-on-btn"
                      : "d-none"
                  }
                  onClick={() => this.handleVideo(false)}
                >
                  <i className="fas fa-video"></i>
                </span>
                <span
                  className={
                    !this.state.videoAllow
                      ? "ml-2 video-call-btn video-on-btn"
                      : "d-none"
                  }
                  onClick={() => this.handleVideo(true)}
                >
                  <i className="fas fa-video-slash"></i>
                </span>
                {/* <span
                  className={
                    !this.state.videoCallTimer
                      ? "ml-2 video-call-btn pause-btn"
                      : "d-none"
                  }
                  onClick={() => this.stopVideoTimer(true)}
                >
                  <i className="fas fa-pause"></i>
                </span> */}
                {/* <span
                  className={
                    this.state.videoCallTimer
                      ? "ml-2 video-call-btn pause-btn"
                      : "d-none"
                  }
                  onClick={() => this.startVideoTimer(false)}
                >
                  <i className="fas fa-play"></i>
                </span> */}
                <span
                  className="ml-2 video-call-btn end-call-btn"
                  onClick={
                    this.state.bookingData &&
                      this.state.bookingData.directCall === false
                      ? this.closeVideoCallScreen
                      : this.askForEndCall
                  }
                >
                  <i className="fas fa-phone-slash"></i>
                </span>
                <span
                  className={
                    this.state.pictureInPictureBtnState
                      ? "ml-2 video-call-btn picture-in-pic-btn"
                      : "d-none"
                  }
                  onClick={this.enablePictureInPicture}
                >
                  <i className="fas fa-images"></i>
                </span>
              </div>
            </div>
          </div>
        </Draggable>
        {/* Calling Patient Now Pop-up */}
        <Modal
          openModal={this.state.callingPatientPopupState}
          modalBodyContent="Calling Patient…Please Wait"
          okayText="Okay"
          cancelText="Okay"
          title="Calling Patient"
          useOneButton={true}
          noButtons={true}
          okayEvent={() => {
            console.log("Okay");
          }}
          cancelEvent={() => {
            console.log("Cancel");
          }}
          backdrop="static"
        />
        {/* End Call With Patient Confirmation pop-up */}
        <Modal
          openModal={this.state.endVideoCallPopUp}
          modalBodyContent="Are you sure you want to end this consult?"
          okayText="Confirm"
          cancelText="Cancel"
          title="Disconnecting Video Call"
          useOneButton={false}
          okayEvent={this.handleEndVideoCall}
          cancelEvent={this.cancelEndVideoCall}
          backdrop="static"
        />
        {/*Patient rejected video call after doctor push the call button */}
        {/* <Model
          openModal={this.state.patientRejectedVideoCallFromDoctorState}
          modalBodyContent={
            this.state.patientRejectedVideoCallFromDoctorContent
          }
          okayText="Okay"
          cancelText="Okay"
          title="Patient Rejected Consult"
          useOneButton={true}
          okayEvent={this.handlePatientRejectedVideoCallFromDoctor}
          cancelEvent={this.handlePatientRejectedVideoCallFromDoctor}
          backdrop="static"
        /> */}
        {/*  Doctor ends the call and receipt received */}
        <Modal
          openModal={this.state.paymentReceiptReceivedOnEndCallState}
          modalBodyContent={this.state.paymentReceiptReceivedOnEndCallContent}
          okayText="Okay"
          cancelText="Okay"
          title="Call Disconnected"
          useOneButton={true}
          okayEvent={this.goToConsultSummaryOnEndCall}
          cancelEvent={this.goToConsultSummaryOnEndCall}
          backdrop="static"
        />
        <Modal openModal={this.state.showCancelConsultPopup}
          okayText="Cancel Consult"
          cancelText="Dismiss"
          title="Reason for Cancelling"
          okayEvent={() => this.cancelConsult()}
          cancelEvent={this.closeCancelConsultPopup}
          child={<ICInput
            required={true}
            error={this.state.cancelConsultReasonError}
            className="text-area"
            label="Reason for Consult Cancellation:"
            onChange={(event) => {
              this.setState({
                cancelConsultReason: event.target.value
              });
            }}
            value={this.state.cancelConsultReason}
          />}
          backdrop="static"
        />

        {/* When patient disconnected from video call due to poor connection */}
        <Modal
          openModal={this.state.patientDisconnected && this.state.showVideoContainer}
          modalBodyContent="This consult has ended due to poor connection. <br/> Please contact our support team on 1300 003 310 <br/> so we can assist."
          okayText="Retry"
          cancelText="End Call"
          title="Poor Connection"
          useOneButton={true}
          okayEvent={this.handlePatientDisconnectedRetry}
          cancelEvent={this.closeVideoCallScreen}
          backdrop="static"
        />
        <Modal
          openModal={this.state.patientCancelledRequest}
          modalBodyContent="Patient has cancelled their <br/> Consult Request"
          okayText="Okay"
          cancelText="Okay"
          title="Consult Cancelled"
          useOneButton={true}
          okayEvent={this.patientCancelledRequestFromAdmin}
          cancelEvent={this.patientCancelledRequestFromAdmin}
          backdrop="static"
        />

        <Modal
          openModal={this.state.patientDeviceIssuePopup}
          modalBodyContent="Video call connection unsuccessful<br/>Please attempt to phone call the patient"
          okayText="Okay"
          cancelText="Okay"
          title="Instant Consult"
          useOneButton={true}
          okayEvent={this.handleOkayPatientDeviceIssuePopup}
          cancelEvent={this.handleOkayPatientDeviceIssuePopup}
          backdrop="static"
        />

        {/* Device issue with patient device */}
        <Modal
          openModal={this.state.patientDeviceIssueState}
          modalBodyContent={this.state.patientDeviceIssueContent}
          okayText="Okay"
          cancelText="Okay"
          title="Patient Device Issue"
          useOneButton={true}
          okayEvent={this.patientDeviceIssue}
          cancelEvent={this.patientDeviceIssue}
          backdrop="static"
        />

        {/* Please wait */}
        <Modal
          openModal={this.state.pleaseWait}
          modalBodyContent={"Please Wait..."}
          okayText="Okay"
          cancelText="Okay"
          title="Instant Consult"
          useOneButton={true}
          noButtons={true}
          okayEvent={() => { }}
          cancelEvent={() => { }}
          backdrop="static"
        />

        {/* Loader */}
        <Loader loading={this.state.isLoading} />
        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />
        <MakeAPICall apiParam={this.state.apiCall1} />
      </div>
    );
  }
}

// export default CallRequestAccepted;

const mapStateToProps = props => ({
  commonReducers: props.commonReducers || null,
  userData:
    props.auth && props.auth.user && props.auth.user.userData
      ? props.auth.user.userData
      : {}
});

const mapDispatchToProps = dispatch => ({
  doctorOnlineState: data => dispatch(doctorOnlineState(data)),
  doctorAppointmentData: data => dispatch(doctorAppointmentData(data)),
  saveVideoCallData: data => dispatch(saveVideoCallData(data)),
  saveSessionId: data => dispatch(saveSessionId(data)),
  saveTimerStatus: data => dispatch(saveTimerStatus(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CallRequestAccepted));

function send(message) {
  //attach the other peer username to our messages
  if (connectedUser) {
    message.name = connectedUser;
  }
  conn.send(JSON.stringify(message));
}

function pictureInPictureLeaveEvent(event) {
  event.preventDefault();
  const remoteVideoEle = document.querySelector("#remoteVideo");
  if (remoteVideoEle) {
    remoteVideoEle.play();
    const videoPlayInterval = setInterval(() => {
      remoteVideoEle.play();
    }, 250);
    setTimeout(() => {
      clearInterval(videoPlayInterval);
    }, 1000);
  }
}
